import { html } from "../../render";
import { attr, cn, safeRandomId, spreadAttrs } from "../../utils";
import { LpIcon } from "../icon";
const rootManagedAttrs = ["data-lp-component", "class", "data-open"];
const triggerManagedAttrs = [
    "data-lp-part",
    "data-lp-collapsible-label",
    "class",
    "type",
    "aria-expanded",
    "aria-controls",
    "aria-label",
];
const panelManagedAttrs = ["data-lp-part", "class", "id", "aria-hidden", "inert"];
function LpCollapsibleRoot({ trigger, panel, open = false, className, attributes, }) {
    const context = {
        open,
        panelId: `lp-collapsible-panel-${safeRandomId()}`,
    };
    return html `
        <lp-collapsible
            data-lp-component="Collapsible"
            class="${cn("lp-collapsible", className, attributes?.class)}"
            ${attr("data-open", open)}
            ${spreadAttrs(attributes, { omit: rootManagedAttrs })}
        >
            ${trigger(context)}
            ${panel(context)}
        </lp-collapsible>
    `;
}
function LpCollapsibleTrigger({ open, panelId, label, openText = "Collapse", closedText = "Expand", className, attributes, }) {
    return html `
        <button
            data-lp-part="trigger"
            data-lp-collapsible-label="${label}"
            class="${cn("lp-collapsible_trigger", className, attributes?.class)}"
            type="button"
            aria-expanded="${String(open)}"
            aria-controls="${panelId}"
            aria-label="${open ? "Collapse" : "Expand"} ${label}"
            ${spreadAttrs(attributes, { omit: triggerManagedAttrs })}
        >
            <span class="lp-collapsible_trigger-label" aria-hidden="true">
                <span class="lp-collapsible_open-label">${openText}</span>
                <span class="lp-collapsible_closed-label">${closedText}</span>
            </span>
            <span class="lp-collapsible_trigger-icon" aria-hidden="true">
                <span class="lp-collapsible_open-icon">${LpIcon({ name: "caret-up", size: 12 })}</span>
                <span class="lp-collapsible_closed-icon">${LpIcon({ name: "caret-down", size: 12 })}</span>
            </span>
        </button>
    `;
}
function LpCollapsiblePanel({ open, panelId, children, className, attributes, }) {
    return html `
        <div
            data-lp-part="panel"
            class="${cn("lp-collapsible_panel", className, attributes?.class)}"
            id="${panelId}"
            ${attr("aria-hidden", open ? undefined : "true")}
            ${attr("inert", open ? undefined : true)}
            ${spreadAttrs(attributes, { omit: panelManagedAttrs })}
        >
            <div class="lp-collapsible_panel-overflow">${children}</div>
        </div>
    `;
}
export const LpCollapsible = {
    Root: LpCollapsibleRoot,
    Trigger: LpCollapsibleTrigger,
    Panel: LpCollapsiblePanel,
    DefaultTrigger: LpCollapsibleTrigger,
    DefaultPanel: LpCollapsiblePanel,
};
